import React, { useCallback, useMemo, useState, useId } from "react";
import { Col, Collapse, Input, Row, Select } from "antd";
import { useSelector } from "react-redux";
import { SearchOutlined } from "@ant-design/icons";
import faqsStyle from "../styles/sass/faqs.module.scss";
import constants from "../utils/Constants";
import { removeInlineStyleColor } from "../utils/CommonFunctions";
import bannerImage from "../../public/assets/images/banner-img-top-4.jpg";
import { overviewData, sliderThumbData } from '../other-object/ObjAccordion';
import Overview from '../components/common-components/overview/Overview';
import BannerInner from "../components/common-components/bannerinner/BannerInner";
import FaqListing from "../components/common-components/faqs/FaqListing";

const { Panel } = Collapse;
const { CMS_TYPES } = constants;

const Faq = () => {

  //const id_faq = userId();
  const { cmsMap, faqCategoryIds } = useSelector(({ cms }) => {
    const { cmsMap, boards } = cms;

    const faqBoardKey = JSON.stringify({ type: CMS_TYPES.FAQ });
    const faqCategoryIds = boards[faqBoardKey]?.list || [];

    return { cmsMap, faqCategoryIds };
  });

  const [state, setState] = useState({});

  const faqs = useMemo(() => {
    let faqs = [];
    faqCategoryIds.forEach((id) => {
      if (!state.category || state.category === id) {
        const faqCategory = cmsMap[id];

        const qnas = faqCategory?.meta?.qna;
        if (qnas?.length > 0) {
          qnas.forEach((qna) => {
            const question = qna?.question?.toLowerCase?.() || "";
            const answer = qna?.answer?.toLowerCase?.() || "";
            const searchText = state?.text?.trim?.()?.toLowerCase?.() || "";

            if (
              !searchText ||
              question.includes(searchText) ||
              answer.includes(searchText)
            ) {
              const mAnswer = removeInlineStyleColor(qna.answer);
              faqs.push({ ...qna, answer: mAnswer, categoryId: id });
            }
          });
        }
      }
    });

    return faqs;
  }, [state, faqCategoryIds, cmsMap]);

  const handleChange = useCallback(
    (name) => (e) => {
      const value = e?.target?.value ?? e;

      setState((prevState) => ({ ...prevState, [name]: value }));
    },
    []
  );

  const faqItem = useCallback(
    (faq, i) => {
      return (
                <FaqListing
                  key={i}
                  title={faq.question}
                  description={faq.answer}
                />
      );
    },
    []
  );

  return (
    <>
      <BannerInner title={"FAQ's"} imageSrc={bannerImage} />
      <section className={`mc_container_fluid p-spacerB p-spacerT select_faq ${faqsStyle["faqs-cb"]}`}>
          <div className="mc_row_new">
          <div className="mc_container_inner">
            <div className={`mc_row_new  ${faqsStyle["faq-main-cb"]}`}> 
              <div className={`${faqsStyle["faq-select-cb"]} ${faqsStyle["faq-box-l-cb"]}`}>
                    <Select
                      className= {`${faqsStyle["form-field-select"]} no-icon-prefix ${faqsStyle["dd-arrow"]}`}
                      dropdownClassName="custom-select-dropdown"
                      placeholder="All"
                      value={state.category}
                      onChange={handleChange("category")}
                    >
                      <Select.Option key={"all"} value={""}>
                        All
                      </Select.Option>

                      {faqCategoryIds?.map((cId) => (
                        <Select.Option key={cId} value={cId}>
                          {cmsMap[cId]?.name}
                        </Select.Option>
                      ))}
                    </Select>
                </div>

                <div className={`${faqsStyle["faq-search-cb"]} ${faqsStyle["faq-box-r-cb"]}`}>
                    <Input
                  className={`${faqsStyle["form-field"]}`}
                    size="large"
                    prefix={<SearchOutlined />}
                    placeholder="Search"
                    value={state.text}
                    onChange={handleChange("text")}
                  />
                </div>

            </div>
          </div>
            {faqs?.length > 0 && (
              <>
              <div className="mc_container_inner">
                {faqs.map((faq, idx) => faqItem(faq, idx))}
              </div>
              </>
            )}
        </div>
      </section>
      
    </>
  );
};

export default React.memo(Faq);
